<template>
    <div class="member-import-operate-detail">
        <bread-crumb :list="[{
            text: '商品',
            url: '/main/goodsLibrary/nav/goodsList'
        }, {
            text: '商品导入',
            url: $route.params.from || '/main/goodsLibrary/goodsImport'
        }, {
            text: '记录详情'
        }]"/>
        <div v-loading="isLoading" class="member-import-operate-detail__info">
            <div class="member-import-operate-detail__info-item">
                <div class="fx-v-center">
                    <span class="des">操作时间：</span>
                    <span>{{ record.create_time }}</span>
                </div>
                <div class="fx-v-center">
                    <span class="des">操 作 人 ：</span>
                    <span>
                        <user-info :userInfo="get(record, 'creator.user') || {}" />
                    </span>
                </div>
            </div>
            <div class="member-import-operate-detail__info-item">
                <div class="fx-v-center">
                    <span class="des">导入商品：</span>
                    <span>{{ record.goods_imported }}条</span>
                </div>
                <div class="fx-v-center">
                    <span class="des">导入方式：</span>
                    <span class="text-popper" style="width: 300px" v-textPopper>{{ '表格导入' }}<span v-if="record.ls_shop_name" class="color-999" style="display: inline">（{{ record.ls_shop_name }}）</span></span>
                </div>
            </div>
        </div>
        <el-table v-loading="isLoading"
            ref="elTable"
            :data="tableData"
            :height="'calc(100vh - 229px)'">
            <el-table-column
                type="index"
                label="#"
                width="50"
                :fixed="tableData.length > 0">
            </el-table-column>
            <el-table-column
                label="一级分组"
                prop="primary_group_name"
                min-width="100"
                :fixed="tableData.length > 0">
            </el-table-column>
            <el-table-column
                label="二级分组"
                prop="secondary_group_name"
                min-width="100"
                :fixed="tableData.length > 0">
            </el-table-column>
            <el-table-column
                label="商品名称"
                prop="goods_name"
                min-width="160"
                :fixed="tableData.length > 0">
            </el-table-column>
            <el-table-column
                label="商品类目"
                prop="goods_category"
                min-width="80">
            </el-table-column>
            <el-table-column
                label="进价"
                prop="purchase_price"
                min-width="100">
                <template v-slot="{ row }">
                    <template v-if="row.purchase_price && row.unit_name">
                        <span>{{ `${row.purchase_price}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="零售价"
                prop="first_tier_price"
                min-width="100">
                <template v-slot="{ row }">
                    <template v-if="row.first_tier_price && row.unit_name">
                        <span>{{ `${row.first_tier_price}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="二级阶梯价"
                prop="second_tier_price"
                min-width="130">
                <template v-slot="{ row }">
                    <template v-if="row.second_tier_price && row.second_tier_threshold && row.unit_name">
                        <span>{{ `${row.second_tier_price || 0}${row.unit_name}` }}, </span>
                        <span>{{ `${row.second_tier_threshold}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="三级阶梯价"
                prop="third_tier_price"
                min-width="130">
                <template v-slot="{ row }">
                    <template v-if="row.third_tier_price && row.third_tier_threshold && row.unit_name">
                        <span>{{ `${row.third_tier_price}${row.unit_name}` }}, </span>
                        <span>{{ `${row.third_tier_threshold}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="会员价"
                prop="member_price"
                min-width="100">
                <template v-slot="{ row }">
                    <template v-if="row.member_price && row.unit_name">
                        <span>{{ `${row.member_price}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="销售单位"
                prop="unit_name">
            </el-table-column>
            <el-table-column
                label="商品库存"
                prop="stock"
                min-width="80">
                <template v-slot="{ row }">
                    <template v-if="row.stock && row.unit_name">
                        <span>{{ `${row.stock}${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="商品编码"
                prop="goods_code"
                min-width="130">
            </el-table-column>
            <el-table-column
                label="商品条码"
                prop="goods_barcode"
                min-width="130">
            </el-table-column>
            <el-table-column width="20" />
            <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && tableData.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
    </div>
</template>

<script lang="ts">
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'
import BreadCrumb from '@/components/bread_crumb/bread_crumb.vue'
import $fetch from '../../../api'
import { openMessage, useScrollLoad } from '../../../utils/system'
import get from 'lodash/get'
import clone from 'lodash/cloneDeep'

interface IImportRecordDetailParams {
    page: number
    limit: number
    record_id: number
}

export default createComponent({
    setup: (props, ctx) => {
        const isLoading = ref(false)
        const record = ref<{ [prop: string]: any }>({})
        const tableData = ref<any[]>([])
        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        const recordId = +ctx.root.$route.query.recordId

        onBeforeMount(() => {
            isLoading.value = true
            getImportRecordDetail()
                .then(() => isLoading.value = false)
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getImportRecordDetail
            })
        })

        async function getImportRecordDetail(page = oPage.value, limit = 20, record_id: number = recordId) {
            try {
                if (!record_id) {
                    return openMessage('error', '无效recordId')
                }
                const params: IImportRecordDetailParams = {
                    page,
                    limit,
                    record_id
                }
                const result = await $fetch.post({
                    url: '/goods/migration/goodsimportedrecordsdetail',
                    params
                })
                console.log('导入详情', clone(result))
                if (page === 1) {
                    record.value = result.record
                    tableData.value = result.goods
                    initScrollLoad(result)
                } else {
                    tableData.value = tableData.value.concat(result.goods)
                }
                return result
            } catch (e) {
                openMessage('error', e.message || '获取导入详情失败')
            }
        }

        return {
            isLoading,
            isScrollLoading,
            isHasMore,
            record,
            tableData,
            get
        }
    },
    components: {
        BreadCrumb
    }
})
</script>

<style lang="scss" scoped>
.member-import-operate-detail {
    font-size: 14px;
    color: #333;

    &__info {
        padding: 12px;
        background-color: #F9F9F9;

        &-item {
            display: flex;
            align-items: center;

            > div {
                flex: none;

                &:first-child {
                    .des + span {
                        width: 160px;
                    }
                }

                &:not(:first-child) {
                    margin-left: 66px;
                }

                > .des {
                    width: 70px;
                }
            }

            span {
                display: inline-block;
                height: 20px;
                line-height: 20px;
            }

            &:not(:first-child) {
                margin-top: 12px;
            }
        }
    }
}

::v-deep .el-table {
    margin-top: 20px !important;
}
</style>
